// src/confluence/space/types.ts
var ConfluenceSpaceAriResourceOwner = "confluence", ConfluenceSpaceAriResourceType = "space";

export {
  ConfluenceSpaceAriResourceOwner,
  ConfluenceSpaceAriResourceType
};
